import { Injector } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { ListColumn, ListDataColumn } from "../../../shared/ui/Data/ListColumn";
import { OperatorEnum } from "../../../shared/ui/OperatorUtil";
import { AuthService } from "../../../shared/service/auth-service/auth-service.service";
import { LABELSTYLE } from "../../../shared/ui/Constants";

export class FieldDefinitionConditions {
  constructor(private injector: Injector) { }

  mahsConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'Local Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'MAH (Code)',
        description: 'Search by code',
        lookup: {
          name: 'organisation',
          parameters: [["type", 1]],
          description: 'Select MAH Code',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'Validated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'validatedUpdated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'Validated and Updated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorValidatedUpdated
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'Nullified',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'name_Org',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'MAH (Name)',
        lookup: {
          name: 'organisation',
          parameters: [["type", 1]],
          description: 'Select MAH Name',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name')
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    },
    {
      className: 'flex-1',
      key: 'countrycode',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'Country',
        lookup: 'country',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'city',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'City',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'region',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'State',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'address',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'Address',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'organisationsenderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        description: "Search by name",
        label: 'MAH Sender ID',
        lookup: {
          name: 'senderid',
          description: 'MAH Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'owned',
      type: 'conditionQuerySelectType',
      hide: this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'Owned',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'Sender ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mahsConditions'],
        label: 'Sender Name',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Search for names of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    }
  ];

  sponsorConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Local Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Sponsor (Code)',
        description: 'Search by code',
        lookup: {
          name: 'organisationdetails',
          parameters: [["type", 2]],
          description: 'Select Sponsor code',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Validated', ListDataColumn.TEXT, 'validated'),
            new ListColumn('Sender HQ Name', ListDataColumn.TEXT, 'senderhqname'),
            new ListColumn('Sender Name', ListDataColumn.TEXT, 'sendername'),
            new ListColumn('Type', ListDataColumn.TEXT, 'typeorg')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Validated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'validatedUpdated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Validated and Updated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorValidatedUpdated
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Nullified',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'name_Org',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Sponsor (Name)',
        description: 'Search by name',
        lookup: {
          name: 'organisationdetails',
          parameters: [["type", 2]],
          description: 'Select Sponsor Name',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Validated', ListDataColumn.TEXT, 'validated'),
            new ListColumn('Sender HQ Name', ListDataColumn.TEXT, 'senderhqname'),
            new ListColumn('Sender Name', ListDataColumn.TEXT, 'sendername'),
            new ListColumn('Type', ListDataColumn.TEXT, 'typeorg')
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'owned',
      type: 'conditionQuerySelectType',
      hide: this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Owned',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual,
      },
    },
    {
      className: 'flex-1',
      key: 'address',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Address',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'countrycode',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Country',
        lookup: 'country',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'city',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'City',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'region',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'State',
        isfreetext: true
      },
    },

    {
      className: 'flex-1',
      key: 'organisationsenderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Sponsor Sender ID',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Sponsor Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Sender ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sponsorConditions'],
        label: 'Sender Name',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Search for names of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    }

  ];

  atcCodeConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'type_Term',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'Type',
        conditionType: OperatorEnum.OperatorEqual,
        lookup: 'type_Term'
      },
    },
    {
      className: 'flex-1',
      key: 'atccode',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'ATC Code',
        description: 'Search by code',
        lookup: {
          name: 'atc',
          description: 'Select ATC Code',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('ATC Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'Validated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'deprecated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'Deprecated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'validatedUpdated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'Validated and Updated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorValidatedUpdated
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'Nullified',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'atccode_Desc',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'ATC Code Description',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'versiondate',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'Version Date',
        conditionType: OperatorEnum.OperatorEqual,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'versiondatefrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'Version Date (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'versiondateupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'Version Date (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'owned',
      type: 'conditionQuerySelectType',
      hide: this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'Owned',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'Sender ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['atcCodeConditions'],
        label: 'Sender Name',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Search for names of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    }
  ]

  sourceConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sourceConditions'],
        label: 'Local Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sourceConditions'],
        label: 'Source (Code)',
        description: 'Search by code',
        lookup: {
          name: 'source',
          description: 'Select Source Code',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['sourceConditions'],
        label: 'Validated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAOrganisation();
      },
    },
    {
      className: 'flex-1',
      key: 'validatedUpdated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['sourceConditions'],
        label: 'Validated and Updated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorValidatedUpdated
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['sourceConditions'],
        label: 'Nullified',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'sourcename',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sourceConditions'],
        label: 'Source (Name)',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['sourceConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'owned',
      type: 'conditionQuerySelectType',
      hide: this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['sourceConditions'],
        label: 'Owned',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sourceConditions'],
        label: 'Sender ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['sourceConditions'],
        label: 'Sender Name',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Search for names of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    }
  ]

  pharmaceuticalFormsConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'type_Term',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Type',
        conditionType: OperatorEnum.OperatorEqual,
        lookup: 'type_Term'
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Local Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Pharmaceutical Form (Code)',
        description: 'Search by code',
        lookup: {
          name: 'pharmform',
          description: 'Select Pharmaceutical Form',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Validated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'deprecated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Deprecated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'validatedUpdated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Validated and Updated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorValidatedUpdated
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Nullified',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'name_Pharmform',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Pharmaceutical Form (Name)',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'versiondate',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Version Date',
        conditionType: OperatorEnum.OperatorEqual,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'versiondatefrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Version Date (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'versiondateupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Version Date (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'owned',
      type: 'conditionQuerySelectType',
      hide: this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Owned',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Sender ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['pharmaceuticalFormsConditions'],
        label: 'Sender Name',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Search for names of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    }

  ]

  roaConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'type_Term',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Type',
        conditionType: OperatorEnum.OperatorEqual,
        lookup: 'type_Term'
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Local Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Route of Administration (Code)',
        description: 'Search by code',
        lookup: {
          name: 'adminroute',
          description: 'Select Route of Administration',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Validated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'deprecated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Deprecated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'validatedUpdated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Validated and Updated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorValidatedUpdated
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Nullified',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'name_Admroute',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Route of Administation (Name)',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'versiondate',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Version Date',
        conditionType: OperatorEnum.OperatorEqual,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'versiondatefrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Version Date (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'versiondateupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Version Date (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'owned',
      type: 'conditionQuerySelectType',
      hide: this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Owned',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Sender ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['roaConditions'],
        label: 'Sender Name',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Search for names of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    }
  ]

  attachmentConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'Local Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'EV Code',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'filename',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'File Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'attachmentname',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'Attachment Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'attachmenttype',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'Type',
        lookup: 'attachmenttype',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'languagecode',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'Language',
        lookup: 'language',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'owned',
      type: 'conditionQuerySelectType',
      hide: this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'Owned',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'Sender ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'Sender Name',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Search for names of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    },
    {
      className: 'flex-1',
      key: 'datesent',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'Date Sent',
        conditionType: OperatorEnum.OperatorEqual,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'datesentfrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'Date Sent (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'datesentupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['attachmentConditions'],
        label: 'Date Sent (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    }
  ]

  mflConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Local Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Master File Location (Code)',
        description: 'Search by code',
        lookup: {
          name: 'mfl',
          description: 'Select Master File Location',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Address', ListDataColumn.TEXT, 'street'),
            new ListColumn('Country', ListDataColumn.TEXT, 'country'),
            new ListColumn('Postcode', ListDataColumn.TEXT, 'postcode'),
            new ListColumn('State', ListDataColumn.TEXT, 'state'),
            new ListColumn('City', ListDataColumn.TEXT, 'city'),
            new ListColumn('Building', ListDataColumn.TEXT, 'building'),
            new ListColumn('Department', ListDataColumn.TEXT, 'department'),
            new ListColumn('Company', ListDataColumn.TEXT, 'companyname')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'mflcompany',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Company Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'mfldepartment',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Department',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'mflbuilding',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Building',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'mflstreet',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Street',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'mflcity',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'City',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'mflstate',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'State',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'mflpostcode',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Postcode',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'mflcountrycode',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Country',
        lookup: 'country',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Nullified',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        },
      },
    },
    {
      className: 'flex-1',
      key: 'owned',
      type: 'conditionQuerySelectType',
      hide: this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Owned',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Sender ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Sender Name',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Search for names of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    },
    {
      className: 'flex-1',
      key: 'datesent',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Date Sent (On)',
        conditionType: OperatorEnum.OperatorEqual,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'datesentfrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Date Sent (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'datesentupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['mflConditions'],
        label: 'Date Sent (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    }
  ]

  approvedSubstancesConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        autocomplete: 'PLEASE_DO_NOT_AUTOCOMPLETE',
        label: 'Local Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        label: 'Substance (Code)',
        description: 'Search by code',
        lookup: {
          name: 'substance',
          parameters: [["type", 2]],
          description: 'Select Substance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Language', ListDataColumn.TEXT, 'language'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type'),
            new ListColumn('Validated', ListDataColumn.YESNODATETIME, 'validated'),
            new ListColumn('Primary', ListDataColumn.LOOKUP, 'isprimary', 'yesNo'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'fk_previous_version',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        label: 'Has Been Updated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        label: 'Validated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'validatedUpdated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        label: 'Validated and Updated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorValidatedUpdated
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdated',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        label: 'Last Updated (On)',
        conditionType: OperatorEnum.OperatorEqual,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdatedfrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        label: 'Last Update (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdatedupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        label: 'Last Update (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        label: 'Nullified',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'substancename',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        autocomplete: 'PLEASE_DO_NOT_AUTOCOMPLETE',
        label: 'Substance (Name)',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'intcode',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        autocomplete: 'PLEASE_DO_NOT_AUTOCOMPLETE',
        label: 'Substance International Code',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'casnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        autocomplete: 'PLEASE_DO_NOT_AUTOCOMPLETE',
        label: 'CAS Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'molecularformula',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        autocomplete: 'PLEASE_DO_NOT_AUTOCOMPLETE',
        label: 'Molecular Formula',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'code_source',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        label: 'Source (Code)',
        description: 'Search by code',
        lookup: {
          name: 'source',
          description: 'Select Source Code',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sourcename',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        autocomplete: 'PLEASE_DO_NOT_AUTOCOMPLETE',
        label: 'Source (Name)',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        label: 'Is Updatable',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'owned',
      type: 'conditionQuerySelectType',
      hide: this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        label: 'Owned',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        autocomplete: 'PLEASE_DO_NOT_AUTOCOMPLETE',
        label: 'Sender ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['approvedSubstancesConditions'],
        autocomplete: 'PLEASE_DO_NOT_AUTOCOMPLETE',
        label: 'Sender Name',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Search for names of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    },
  ]

  substancesNamesConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'substancename',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['substancesNamesConditions'],
        label: 'Name',
        description: 'Search by name',
        lookup: {
          name: 'substance',
          description: 'Select Substance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Language', ListDataColumn.TEXT, 'language'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type'),
            new ListColumn('Validated', ListDataColumn.YESNODATETIME, 'validated'),
            new ListColumn('Primary', ListDataColumn.LOOKUP, 'isprimary', 'yesNo'),
          ],
          type: 'R',
          result: 'selectedName'
        }
      },
    },
    {
      className: 'flex-1',
      key: 'nameType',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['substancesNamesConditions'],
        label: 'Name Type',
        conditionType: OperatorEnum.OperatorEqual,
        lookup: 'substanceNameTypes'
      },
    },
  ]

  developmentSubstancesConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Local Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Substance (Code)',
        description: 'Search by code',
        lookup: {
          name: 'substance',
          parameters: [["type", 1]],
          description: 'Select Substance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Language', ListDataColumn.TEXT, 'language'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type'),
            new ListColumn('Validated', ListDataColumn.YESNODATETIME, 'validated'),
            new ListColumn('Primary', ListDataColumn.LOOKUP, 'isprimary', 'yesNo'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'fk_previous_version',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Has Been Updated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Validated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'validatedUpdated',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Validated and Updated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorValidatedUpdated
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdated',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Last Update (On)',
        conditionType: OperatorEnum.OperatorEqual,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdatedfrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Last Update (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdatedupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Last Update (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Nullified',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'substancename',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Substance (Name)',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'iscode',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Is Name or Code',
        lookup: 'substancenameorcode',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'casnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'CAS Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'molecularformula',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Molecular Formula',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'name_Org',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Sponsor (Name)',
        description: 'Search by name',
        lookup: {
          name: 'organisationdetails',
          parameters: [["type", 2]],
          description: 'Select Sponsor Name',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Validated', ListDataColumn.TEXT, 'validated'),
            new ListColumn('Sender HQ Name', ListDataColumn.TEXT, 'senderhqname'),
            new ListColumn('Sender Name', ListDataColumn.TEXT, 'sendername'),
            new ListColumn('Type', ListDataColumn.TEXT, 'typeorg')
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    },
    {
      className: 'flex-1',
      key: 'organisation_ev_code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Sponsor (Code)',
        description: 'Search by code',
        lookup: {
          name: 'organisation',
          parameters: [["type", 2]],
          description: 'Select Sponsor Code',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Is Updatable',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Sender ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentSubstancesConditions'],
        label: 'Sender Name',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Search for names of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    }
  ]

  authorisedProductsConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'art57',
      type: 'conditionQuerySelectTypeWithDefaultValue',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Article 57 Format',
        lookup: 'art57Format',
        conditionType: OperatorEnum.OperatorIn,
        defaultValue: 0,
        permanentCheck: true,
        conditionTypeValue: ListDataColumn.LOOKUP
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Local Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'EV Code',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'fk_previous_version',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Has Been Updated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'product_validity',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Product Validity',
        lookup: 'validityValues',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'product_pending',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Product Pending',
        lookup: 'pendingValues',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'product_nullified',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Product Nullified',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'product_last_rejected',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Product Last Rejected',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdated',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Last Update (On)',
        conditionType: OperatorEnum.OperatorEqual,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdatedfrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Last Update (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdatedupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Last Update (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'productname',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Full Presentation Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'productshortname',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Product Short Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'productgenericname',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Product INN/Common Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'productstrength',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Product Strength Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'productcompanyname',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Product Company Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'productform',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Product Form Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'countrycode',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Authorisation Country',
        lookup: 'country',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'authorisationprocedure',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Authorisation Procedure',
        lookup: 'authorisationprocedure',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'authorisationstatus',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Authorisation Status',
        lookup: 'authorisationstatus',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'authorisationrenewalfrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Authorisation/Renewal Date (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'authorisationrenewalupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Authorisation/Renewal Date (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'ma_valid',
      type: 'conditionQuerySelectTypeWithDefaultValue',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'MA Validity',
        lookup: 'validityFormat',
        conditionType: OperatorEnum.OperatorIn,
        defaultValue: 1,
        permanentCheck: true,
        conditionTypeValue: ListDataColumn.LOOKUP
      },
    },
    {
      className: 'flex-1',
      key: 'authorisationnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Authorisation Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'mrpnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'MRP/DCP/EMEA Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'eunumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'EU Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'legal_basis',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Legal Basis',
        lookup: 'legalbasis',
        conditionType: OperatorEnum.OperatorContain
      },
    },
    {
      className: 'flex-1',
      key: 'withdrawndate',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Invalidated Date',
        conditionType: OperatorEnum.OperatorEqual,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'withdrawndatefrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Invalidated Date (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'withdrawndateupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Invalidated Date (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'name_Org',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'MAH (Name)',
        lookup: {
          name: 'organisation',
          parameters: [["type", 1]],
          description: 'Select MAH Name',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name')
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    },
    {
      className: 'flex-1',
      key: 'organisation_ev_code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'MAH (Code)',
        description: 'Search by code',
        lookup: {
          name: 'organisation',
          parameters: [["type", 1]],
          description: 'Select MAH Code',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'qppv',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'QPPV (Code)',
        description: 'Search by name',
        disabled: this.injector.get(AuthService).isDatamaskedUser(),
        lookup: {
          name: 'qppv',
          description: 'Select QPPV',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('QPPV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Full Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('First Name', ListDataColumn.TEXT, 'firstName'),
            new ListColumn('Family Name', ListDataColumn.TEXT, 'familyName'),
            new ListColumn('Organisation ID', ListDataColumn.TEXT, 'organisationID'),
            new ListColumn('Organisation Name', ListDataColumn.TEXT, 'organisation'),
            new ListColumn('Role', ListDataColumn.TEXT, 'role'),
            new ListColumn('Responsible', ListDataColumn.TEXT, 'responsible'),
            new ListColumn('Enabled', ListDataColumn.TEXT, 'enabled'),
          ],
          type: 'R',
          disableToggle: true,
        }
      }
    },
    {
      className: 'flex-1',
      key: 'mfl',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Master File Location (Code)',
        description: 'Search by code',
        lookup: {
          name: 'mfl',
          description: 'Select Master File Location',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Address', ListDataColumn.TEXT, 'street'),
            new ListColumn('Country', ListDataColumn.TEXT, 'country'),
            new ListColumn('Postcode', ListDataColumn.TEXT, 'postcode'),
            new ListColumn('State', ListDataColumn.TEXT, 'state')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'name_Pharmform',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Pharmaceutical Form (Code)',
        description: 'Search by code',
        lookup: {
          name: 'pharmform',
          description: 'Select Pharmaceutical Form',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'name_Admroute',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Route of Administration (Code)',
        description: 'Search by code',
        lookup: {
          name: 'adminroute',
          description: 'Select Route of Administration',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'atccode',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'ATC Code',
        description: 'Search by code',
        lookup: {
          name: 'atc',
          description: 'Select ATC Code',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('ATC Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'substance_ev_code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Substance (Code)',
        description: 'Search by code',
        lookup: {
          name: 'substance',
          parameters: [["type", 2]],
          description: 'Select Substance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Language', ListDataColumn.TEXT, 'language'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type'),
            new ListColumn('Validated', ListDataColumn.YESNODATETIME, 'validated'),
            new ListColumn('Primary', ListDataColumn.LOOKUP, 'isprimary', 'yesNo')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'substancename',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Substance (Name)',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'attachmentevcode',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Attachment (Code)',
        description: 'Search by code',
        lookup: {
          name: 'ppiattachment',
          description: 'Select Attachment EV Code',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name')
          ],
          type: 'R',
          disableToggle: true,
        }
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Is Updatable',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'is_nullable',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Is Nullifiable',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'owned',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Owned',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Sender ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['authorisedProductsConditions'],
        label: 'Sender Name',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Search for names of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    }
  ];

  developmentProductsConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Local Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        isfreetext: true,
        label: 'EV Code'
      },
    },
    {
      className: 'flex-1',
      key: 'fk_previous_version',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Has Been Updated',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorIsOrNotNull
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'product_validity',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Product Validity',
        lookup: 'validityValues',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'product_pending',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Product Pending',
        lookup: 'pendingValues',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'product_nullified',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Product Nullified',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdated',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Last Update (On)',
        conditionType: OperatorEnum.OperatorEqual,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdatedfrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Last Update (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdatedupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Last Update (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'productcode',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Product Code',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'productname',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Product Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'productothername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Product Other Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'name_Org',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Sponsor (Name)',
        description: 'Search by name',
        lookup: {
          name: 'organisationdetails',
          parameters: [["type", 2]],
          description: 'Select Sponsor Name',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Validated', ListDataColumn.TEXT, 'validated'),
            new ListColumn('Sender HQ Name', ListDataColumn.TEXT, 'senderhqname'),
            new ListColumn('Sender Name', ListDataColumn.TEXT, 'sendername'),
            new ListColumn('Type', ListDataColumn.TEXT, 'typeorg')
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    },
    {
      className: 'flex-1',
      key: 'organisation_ev_code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Sponsor (Code)',
        description: 'Search by code',
        lookup: {
          name: 'organisation',
          parameters: [["type", 1]],
          description: 'Select Sponsor Code',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Validated', ListDataColumn.TEXT, 'validated'),
            new ListColumn('Sender HQ Name', ListDataColumn.TEXT, 'senderhqname'),
            new ListColumn('Sender Name', ListDataColumn.TEXT, 'sendername'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'name_Pharmform',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Pharmaceutical Form (Code)',
        description: 'Search by code',
        lookup: {
          name: 'pharmform',
          description: 'Select Pharmaceutical Form',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'name_Admroute',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Route of Administration (Code)',
        description: 'Search by code',
        lookup: {
          name: 'adminroute',
          description: 'Select Route of Administration',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'substance_ev_code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Substance (Code)',
        description: 'Search by code',
        lookup: {
          name: 'substance',
          description: 'Select Substance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Language', ListDataColumn.TEXT, 'language'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type'),
            new ListColumn('Validated', ListDataColumn.YESNODATETIME, 'validated'),
            new ListColumn('Primary', ListDataColumn.LOOKUP, 'isprimary', 'yesNo')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'substancename',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Substance (Name)',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'atccode',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'ATC Code',
        description: 'Search by code',
        lookup: {
          name: 'atc',
          description: 'Select ATC Code',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('ATC Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Type', ListDataColumn.TEXT, 'type')
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'attachmentevcode',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Attachment (Code)',
        description: 'Search by code',
        lookup: {
          name: 'ppiattachment',
          description: 'Select Attachment EV Code',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name')
          ],
          type: 'R',
          disableToggle: true,
        }
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Is Updatable',
        lookup: 'binaryYesNo',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'is_nullable',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Is Nullifiable',
        lookup: 'yesNo',
        conditionType: OperatorEnum.OperatorEqual
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Sender ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['developmentProductsConditions'],
        label: 'Sender Name',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Search for names of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true,
          result: 'selectedName'
        }
      },
    }
  ];

  ownedByEVMPDEntitiesConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'conditionQueryLookupInputType',
      hide: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      props: {
        labelstyle: LABELSTYLE['ownedByEVMPDEntitiesConditions'],
        label: 'Owner HQ ID (Code)',
        description: 'Search by name',
        lookup: {
          name: 'senderid',
          description: 'Select Owner HQ ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
  ]

  abstractCompositionsConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'scientificcode',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['abstractCompositionsConditions'],
        label: 'Scientific Code',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'scientificname',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['abstractCompositionsConditions'],
        label: 'Scientific Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'ev_code_pharmform',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['abstractCompositionsConditions'],
        label: 'Scientific Pharmaceutical Form (Code)',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'name_pharmform',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['abstractCompositionsConditions'],
        label: 'Scientific Pharmaceutical Form (Name)',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'productname',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['abstractCompositionsConditions'],
        label: 'Product Linked: Full Presentation Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'productshortname',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['abstractCompositionsConditions'],
        label: 'Product Linked: Product Short Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'substancename',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['abstractCompositionsConditions'],
        label: 'Ingredients: Substance Name',
        isfreetext: true
      },
    },
  ];

  xevprmMessageConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['xevprmMessageConditions'],
        label: 'Message Number',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['xevprmMessageConditions'],
        label: 'Sender ID (Code)',
        isfreetext: false,
        lookup: {
          name: 'senderid',
          description: 'Sender ID',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['xevprmMessageConditions'],
        label: 'Sender Name',
        isfreetext: true
      },
    },
    {
      className: 'flex-1',
      key: 'messagedate',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['xevprmMessageConditions'],
        label: 'Message Date',
        conditionType: OperatorEnum.OperatorEqual,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'messagedatefrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['xevprmMessageConditions'],
        label: 'Message Date (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'messagedateupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['xevprmMessageConditions'],
        label: 'Message Date (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'ackdate',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['xevprmMessageConditions'],
        label: 'Message Ack Date',
        conditionType: OperatorEnum.OperatorEqual,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'ackdatefrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['xevprmMessageConditions'],
        label: 'Message Ack Date (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'ackdateupto',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['xevprmMessageConditions'],
        label: 'Message Ack Date (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan,
        conditionTypeValue: ListDataColumn.DATE
      },
    },
    {
      className: 'flex-1',
      key: 'operationresult',
      type: 'conditionQuerySelectType',
      props: {
        labelstyle: LABELSTYLE['xevprmMessageConditions'],
        label: 'Entity Loading Result',
        lookup: 'operationresultmp',
        conditionType: OperatorEnum.OperatorEqual
      },
    }
  ]

}